import { computed, makeObservable } from 'mobx';
import { IMithrilComponent } from '../../components/mithril.component';
import { T, Translate } from '../../i18n';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { Services } from '../../services';
import { IkePageName } from '../page';
import { Banner, MDL } from './dashboard.style';

export const ROUTES = {
	POLE_STATUS: () => Services.Route.go(IkePageName.dashboardPolestatus),
	POLE_LOADING: () => Services.Route.go(IkePageName.dashboardPoleloading),
	MENU: () => Services.Route.go(IkePageName.dashboardMenu),
};

export class DashBannerComponent extends IMithrilComponent {
	name = 'DashBanner';

	constructor() {
		super();
		makeObservable(this);
	}

	@computed get nodes(): MithrilVNode {
		if (!Services.User.hasUser) {
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			Services.User.logout();
			return null;
		}

		return m('header', { className: Banner.header.container }, [
			m('div', { className: Banner.header.row }, [
				m('div', { className: Banner.header.section }, [
					//this.viewMenuIcon, #Future overview page
					this.viewPoleStatusIcon,
					this.viewPoleLoadingIcon,
				]),
			]),
		]);
	}

	get viewMenuIcon() {
		return m('div', { className: 'button' }, [
			m('button', { className: MDL.button, onclick: ROUTES.MENU, title: Translate(T.DASHBOARD) }, [
				m(
					'span',
					{ className: Banner.menuButton.span, onclick: ROUTES.MENU, title: Translate(T.DASHBOARD) },
					Translate(T.DASHBOARD)
				),
			]),
		]);
	}

	get viewPoleStatusIcon() {
		return m('div', { className: 'button' }, [
			m('button', { className: MDL.button, onclick: ROUTES.POLE_STATUS, title: Translate(T.DASHBOARD_POLE_STATUS) }, [
				m(
					'span',
					{
						className: Services.Route.isPoleStatus() ? Banner.menuButton.spanSelected : Banner.menuButton.span,
						onclick: ROUTES.POLE_STATUS,
						title: Translate(T.DASHBOARD_POLE_STATUS),
					},
					Translate(T.DASHBOARD_POLE_STATUS)
				),
			]),
		]);
	}

	get viewPoleLoadingIcon() {
		return m('div', { className: 'button' }, [
			m('button', { className: MDL.button, onclick: ROUTES.POLE_LOADING, title: Translate(T.DASHBOARD_POLE_LOADING) }, [
				m(
					'span',
					{
						className: Services.Route.isPoleLoading() ? Banner.menuButton.spanSelected : Banner.menuButton.span,
						onclick: ROUTES.POLE_LOADING,
						title: Translate(T.DASHBOARD_POLE_LOADING),
					},
					Translate(T.DASHBOARD_POLE_LOADING)
				),
			]),
		]);
	}
}
export const DashBanner = new DashBannerComponent();
